import { getResourceString, LIST_SCHEMA_BRANCHES } from '@takeshape/actions';
import { getBranchListRoutine } from 'app/branches/actions';
import { getRoutineSaga } from 'app/common/utils/new-sagas';
import { showMessage } from 'app/messages/actions';
import { getPermission } from 'app/permissions/selectors';
import { getCurrentProjectId } from 'app/project/selectors';
import type { SagaIterator } from 'redux-saga';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import type { ActionType } from 'typesafe-actions';
import { getBranchListQuery } from '../api.js';

export function* getBranchListSaga(): SagaIterator {
  const projectId = yield select(getCurrentProjectId);
  if (!projectId) return null;
  const hasPermission = yield select(getPermission, {
    action: LIST_SCHEMA_BRANCHES,
    resource: getResourceString('project', { projectId })
  });
  if (!hasPermission) return null;
  return yield call(getBranchListQuery);
}

export function* getBranchListRejectedSaga({
  payload
}: ActionType<typeof getBranchListRoutine.rejected>): SagaIterator {
  console.error('Failed to fetch branch list:\n\n', payload);
  yield put(showMessage('error', 'Failed to fetch branch list'));
}

export default function* root(): SagaIterator {
  yield all([
    takeLatest(getBranchListRoutine.requested, getRoutineSaga(getBranchListRoutine, getBranchListSaga)),
    takeLatest(getBranchListRoutine.rejected, getBranchListRejectedSaga)
  ]);
}
